<div class="logo">
  <a class="simple-text logo-mini">
    <div class="logo-img">
      <img
        src="./assets/img/logohorizontalpng/logoA_2.png"
        alt=""
        class="logo-mini-img"
      />
    </div>
  </a>
  <a class="simple-text logo-normal"> FinanQro </a>
</div>

<div class="sidebar-wrapper">
  <div class="user">
    <div class="photo">
      <img [src]="fotosidebar" class="picture-src" title="" />>
    </div>
    <div class="user-info">
      <a data-toggle="collapse" href="#collapseExample" class="collapsed">
        <span>
          {{ user ? user.nombre : "" }}
          <b class="caret"></b>
        </span>
      </a>
      <div style="text-align: center">
        <strong *ngIf="user">Suc:{{ sucursal }}</strong>
      </div>
      <div class="collapse" id="collapseExample">
        <ul class="nav">
          <li *ngIf="user" class="nav-item">
            <a class="nav-link" (click)="datosUsuario()"
              ><span class="sidebar-mini">
                <i class="material-icons">manage_accounts</i> </span
              ><span class="sidebar-normal">Ajustes de Usuario</span></a
            >
          </li>

          <li class="nav-item">
            <a class="nav-link" (click)="logout()"
              ><span class="sidebar-mini">
                <i class="material-icons">exit_to_app</i> </span
              ><span class="sidebar-normal">Cerrar Sesi&oacute;n</span></a
            >
          </li>
        </ul>
      </div>
    </div>

    <ul class="nav">
      <li
        routerLinkActive="active"
        *ngFor="let menuitem of menuItems"
        class="nav-item"
      >
        <!--If is a single link-->
        <a
          [routerLink]="[menuitem.factory]"
          *ngIf="menuitem.type === 'link'"
          class="nav-link"
        >
          <i class="material-icons">{{ menuitem.icon }}</i>
          <p style="font-weight: 600">{{ menuitem.nombre }}</p>
        </a>
        <!--If it have a submenu-->
        <a
          data-toggle="collapse"
          href="#{{ menuitem.collapse }}"
          id="{{ menuitem.collapse }}-p"
          *ngIf="menuitem.type === 'sub' && menuitem.subMenu.length > 0"
          (click)="updatePS(); expandOrCollapseMenu(menuitem.collapse)"
          class="nav-link"
        >
          <i class="material-icons">{{ menuitem.icon }}</i>
          <p style="font-weight: 600">
            {{ menuitem.nombre }}<b class="caret"></b>
          </p>
        </a>

        <!--Display the submenu items-->
        <div
          id="{{ menuitem.collapse }}"
          class="collapse"
          *ngIf="menuitem.type === 'sub'"
        >
          <ul class="nav">
            <li
              routerLinkActive="active"
              *ngFor="let childitem of menuitem.subMenu"
              class="nav-item"
            >
              <a [routerLink]="[childitem.factory]" class="nav-link">
                <i class="material-icons">{{ childitem.icon }}</i>
                <span class="sidebar-normal">{{ childitem.nombre }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
